import React from "react";
import "./SymptomsSelector.css";

const SYMPTOM_OPTIONS = [
  { value: "cough_cold", label: "Cough + Cold" },
  { value: "fever", label: "Fever" },
  { value: "stomach_ache", label: "Stomach ache" },
  { value: "headache", label: "Headache" },
  { value: "injury", label: "Injury" },
  { value: "other", label: "Other (Type your own)" },
];

// variant="checklist" swaps the native multi-select for a checkbox list (used
// by the coach's check-in modal). It emits the same { symptoms } payload, so
// callers don't need to care which one they got.
const SymptomsSelector = ({ symptoms, customSymptom, onChange, variant, required = true }) => {
  const handleSymptomChange = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
    onChange({ symptoms: selectedOptions });
  };

  const handleSymptomToggle = (value) => {
    onChange({
      symptoms: symptoms.includes(value)
        ? symptoms.filter((s) => s !== value)
        : [...symptoms, value],
    });
  };

  const handleCustomSymptomChange = (e) => {
    onChange({ customSymptom: e.target.value });
  };

  const showCustomInput = symptoms.includes("other");

  return (
    <div className="symptoms-selector">
      {variant === "checklist" ? (
        <div className="form-group">
          <label>Symptoms <span className="required">*</span></label>
          <div className="symptoms-checklist" role="group" aria-label="Symptoms">
            {SYMPTOM_OPTIONS.map((option) => {
              const checked = symptoms.includes(option.value);
              return (
                <label
                  key={option.value}
                  className={`symptom-check${checked ? " is-checked" : ""}`}
                >
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => handleSymptomToggle(option.value)}
                  />
                  <span>{option.label}</span>
                </label>
              );
            })}
          </div>
          <small className="form-hint">Select all that apply</small>
        </div>
      ) : (
        <div className="form-group">
          <label>Symptoms{required && <> <span className="required">*</span></>}</label>
          <select
            multiple
            value={symptoms}
            onChange={handleSymptomChange}
            className="symptoms-multiselect"
          >
            {SYMPTOM_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <small className="form-hint">Hold Ctrl/Cmd to select multiple symptoms</small>
        </div>
      )}

      {showCustomInput && (
        <div className="form-group">
          <label>Custom Symptom Description{required && <> <span className="required">*</span></>}</label>
          <input
            type="text"
            value={customSymptom}
            onChange={handleCustomSymptomChange}
            placeholder="Type custom symptom here..."
            className="custom-symptom-input"
          />
        </div>
      )}
    </div>
  );
};

export default SymptomsSelector;
